import Accordion from "react-bootstrap/Accordion";
import { useState } from "react";
import "./faq.css";
import { Container } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const accordionData = [
  {
    title: "1. Why Wheat bakes?",
    content:
      "Wheat Bakes specializes in natural cakes made with whole wheat, millet, jaggery, and other healthy ingredients. Visit us at Pondy Bazaar T. Nagar, Chennai or you can book through online from www.wheatbakes.com",
  },
  {
    title: "2. What are ingredients used in your cakes?",
    content:
      "All our cakes are made using 100% whole wheat or 100% millet, offering a healthier alternative to traditional cakes. We also use pure courveture chocolate, jaggery, fresh fruits and nuts filling. Our cream is made of pure butter.",
  },
  {
    title: "3. How do you differ from other bakers?",
    content:
      "Our cakes are free from maida, refined sugar, preservatives, and artificial colors & flavours. All the ingredients are carefully sourced considering natural and chemical free.",
  },
  {
    title: "4. Do you offer homemade cakes?",
    content:
      "Yes, all our cakes are made in-house using fresh, wholesome ingredients to maintain a homemade touch and ensure quality.",
  },
  {
    title: "5. Your cakes suitable for children? ",
    content:
      "Absolutely! Our cakes are made with natural ingredients, making them a clean and guilt-free treat for children.",
  },
  {
    title: "6. Do you offer eggless cakes?",
    content: "Yes, All Our Cakes are 100% eggless cakes.",
  },
  {
    title: "7. Do you bake gluten-free cakes?",
    content:
      "Yes, we have gluten-free options such as millet-based brownies and muffins. Please check availability when placing your order.",
  },
  {
    title: "8. What types of breads do you offer?",
    content:
      "We offer 100% whole wheat bread which has no maida, no palm oil, all baked fresh with no added preservatives.",
  },
  {
    title: "9. Do you offer home delivery?",
    content:
      "While we don’t have direct delivery, you can use services like Porter, or Swiggy Genie to arrange for delivery. Charges apply as per the service.",
  },
  {
    title: "10. What’s the shelf life of your cakes?",
    content:
      "Our cakes, made without preservatives, are best enjoyed fresh. They last up to 3–4 days when refrigerated properly.",
  },
];

function FAQ() {
  const [activeKey, setActiveKey] = useState(null);

  return (
    <>
      <Helmet>
        <title>FAQs – Natural, Eggless & No-Maida Cakes Chennai</title>
        <meta
          name="description"
          content="Find answers about natural ingredient cakes, no-maida baking, healthy whole wheat treats & Chennai cake delivery."
        />
        <link rel="canonical" href="https://wheatbakes.com/faq" />

      </Helmet>
    <div>
      {/* <section className="page-banner overflow-hidden">
        <div class="banner-bg"></div>

        <div className="container">
          <div className="row align-items-center">
            <div class="col-xl-8 col-lg-8 col-md-12">
              <div class="page-banner-content">
                <h1>FAQ</h1>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-12">
              <div class="wheatbakes-breadcrumb">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>FAQ</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <Container>
        <div className="p-3 p-md-5">
          <p className="text-align-center brown-text-color text-bold-600">
            FAQ
          </p>
          <h1 className="text-align-center text-bold-600">
            Have Any Questions?
          </h1>
          <div className="wheatbakes-accordian-container dark-text">
            <Accordion
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
            >
              {accordionData.map((item, index) => (
                <Accordion.Item
                  key={index}
                  eventKey={String(index)}
                  className={
                    activeKey === String(index) ? "accordion-item-active" : ""
                  }
                >
                  <Accordion.Header>{item.title}</Accordion.Header>
                  <Accordion.Body>{item.content}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </Container>
    </div>
    </>
  );
}

export default FAQ;
